import React, { Component } from "react";
import { Card, CardBody, InputGroup, Col, Form, Row, Button } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import DefaultMultipleSelect from "../DefaultMultipleSelect/DefaultMultipleSelect";
import { getCurrentDay } from "../../helpers/utils";
import CustomMultipleDateRange from "../CustomMultipleDateRange/CustomMultipleDateRange";
import { AvForm } from "availity-reactstrap-validation";
import __ from "lodash/fp/__";

class DynamicFormToFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { selectedDate } = this.props;
    this.setState({
      date: {
        start_date:
          selectedDate !== null
            ? selectedDate.start_date
            : new Date(new Date().setDate(1)).toISOString().split("T")[0],
        end_date:
          selectedDate !== null ? selectedDate.end_date : getCurrentDay(),
      },
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        ad_ids: this.props.data.ad_ids,
        campaign_ids: this.props.data.ad_ids,
        campaign_names: this.props.data.campaign_names,
      });
    }

    if (prevProps.selectedDate !== this.props.selectedDate) {
      const { selectedDate } = this.props;
      this.setState({
        date: {
          start_date:
            selectedDate !== null
              ? selectedDate.start_date
              : new Date(new Date().setDate(1)).toISOString().split("T")[0],
          end_date:
            selectedDate !== null ? selectedDate.end_date : getCurrentDay(),
        },
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      date: {
        start_date: new Date(new Date().setDate(1)).toISOString().split("T")[0],
        end_date: getCurrentDay(),
      },
    });
  }

  handleSelect = (data, filterType) => {
    const { date } = this.state;

    let filteredData = {};
    filteredData[filterType] = [];
    data.map(i => filteredData[filterType].push(i.value));

    const update_date = {
      ...filteredData,
      start_date: date.start_date,
      end_date: date.end_date || getCurrentDay(),
    };

    if (date.end_date !== undefined) {
      this.props.onFiltersChange("data", update_date, filterType);
    }
  };

  onFiltersChange = date => {
    this.setState({ date });

    const data = {
      start_date: date.start_date,
      end_date: date.end_date || getCurrentDay(),
    };

    if (date.end_date !== undefined) {
      this.props.onFiltersChange("date", data);
    }
  };

  render() {
    return (
      <StyledRow>
        <Col className="col-12">
          <StyledCard>
            <CardBody
              style={{
                padding: "1.25rem 0",
                ...this.props.style,
              }}
            >
              <FilterContainer className="d-flex justify-content-between align-items-end">
                <div>
                  {this.props.filtersFields && (
                    <div className="col-sm-auto mb-2">
                      <span>Filter by: </span>
                    </div>
                  )}
                  <div className="row gy-1 gx-1 align-items-center">
                    {this.props.filtersFields &&
                      this.props.filtersFields.map((i, key) => (
                        <div className="col-sm-auto" key={key}>
                          <DefaultMultipleSelect
                            options={
                              i.filterData?.length > 0
                                ? i.filterData.map(item => ({
                                    key: item?.id || item,
                                    text: item?.name || item,
                                    checked: item?.checked || false,
                                  }))
                                : []
                            }
                            filtered_by={this.props.filtered_by[key]}
                            filtered_params={this.props.filtered_params}
                            onChange={select =>
                              this.handleSelect(select, i.filterType || __)
                            }
                            plug={i.plug}
                            search
                          />
                        </div>
                      ))}
                  </div>
                </div>
                <div>
                  <div className="gy-2 gx-1 d-flex gap-3 float-end">
                    <div
                      style={{
                        width: "100%",
                        height: 37,
                      }}
                    >
                      <Button
                        color="primary"
                        className={`${
                          this.props.report_type == "quality-report" &&
                          this.props.permissions[
                            "change_qualitynoncohortreport"
                          ]
                            ? ""
                            : "d-none"
                        }`}
                        onClick={this.props.updateReportData}
                        style={{
                          height: "100%",
                          minWidth: "215px",
                          margin: "26px 0 0 0",
                        }}
                      >
                        <i className="mdi mdi-refresh" /> Update dashboard data
                      </Button>
                    </div>
                    <PickerStyled>
                      <p>Date range:</p>
                      <AvForm>
                        <CustomMultipleDateRange
                          value={this.state.date}
                          placeholder="Select date range..."
                          name="date-range-picker-1"
                          datePickerType="round"
                          onChange={date => this.onFiltersChange(date)}
                          customStaticRanges={this.props.customStaticRanges}
                        />
                      </AvForm>
                    </PickerStyled>
                  </div>
                </div>
              </FilterContainer>
            </CardBody>
          </StyledCard>
        </Col>
      </StyledRow>
    );
  }
}

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const PickerStyled = styled(InputGroup)`
  max-width: 220px;
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

DynamicFormToFilter.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  data: PropTypes.any,
  filtersFields: PropTypes.any,
  selectedDate: PropTypes.any,
  autoCheckedAll: PropTypes.bool,
  filtered_params: PropTypes.object,
  filtered_by: PropTypes.array,
  style: PropTypes.object,
  updateReportData: PropTypes.func,
  report_type: PropTypes.string,
  customStaticRanges: PropTypes.bool,
  permissions: PropTypes.any,
};

export default DynamicFormToFilter;
